import { Alert, Grid, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import RotatingLoader from '../common/ui/RotatingLoader';
import { TabsPage } from '../common/components/TabsPage';
import { useGetAccountAuthenticated } from '../session/swr/useGetAccountAuthenticated';
import { AboutTab } from './components/businessDetails/AboutTab';
import { ContactTab } from './components/businessDetails/ContactTab';
import { PoliciesTab } from './components/businessDetails/PoliciesTab';

enum BusinessDetailsTabs {
  ABOUT = 'about',
  CONTACT = 'contact',
  POLICIES = 'policies',
}

export const BusinessDetailsPage = () => {
  const { t } = useTranslation();
  const { account, isLoading, updateLocalAccount } = useGetAccountAuthenticated({});
  const [isUpdatedSnackOpen, setIsUpdatedSnackOpen] = useState(false);

  if (isLoading) {
    return (
      <Grid
        container
        sx={{
          minHeight: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <RotatingLoader />
      </Grid>
    );
  }

  const tabContent = {
    [BusinessDetailsTabs.ABOUT]: (
      <AboutTab
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [BusinessDetailsTabs.CONTACT]: (
      <ContactTab
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
    [BusinessDetailsTabs.POLICIES]: (
      <PoliciesTab
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    ),
  };

  return (
    <Grid container flexDirection="column" height="100%" flexWrap="nowrap" sx={{ minHeight: 0 }}>
      <Snackbar
        open={isUpdatedSnackOpen}
        onClose={() => setIsUpdatedSnackOpen(false)}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert sx={{ width: '100%' }} onClose={() => setIsUpdatedSnackOpen(false)} severity="success" variant="filled">
          {t('storefronts.update_success')}
        </Alert>
      </Snackbar>
      <TabsPage tabContent={tabContent} />
    </Grid>
  );
};
